// import authRoute from '@/configs/routes.config/authRoute';
// import { useLocation } from 'react-router';
import type { CommonProps } from '@/@types/common';
import AuthLayout from './AuthLayout';

const PreLoginLayout = ({ children }: CommonProps) => {
  // const location = useLocation();

  // const { pathname } = location;

  // const isAuthPath = authRoute.some((route) => route.path === pathname);
  const isAuthPath = true;

  return (
    <div className="flex h-[100vh] flex-auto flex-col">
      {isAuthPath ? <AuthLayout>{children}</AuthLayout> : children}
    </div>
  );
};

export default PreLoginLayout;
